<template>
  <Popup :show="show">
    <div class="withdrawal-pop">
      <div class="pop-content">
        <p>提现金额：{{number}}*0.1*80%={{result}}元</p>
        <span>鲸币:人民币=10:1</span>
        <p class="tip">扣除的20%为壹心理代缴税费</p>
      </div>
      <div class="pop-agreement">
        <Checkbox class="checkbox" @input="handleValue" :value="value"></Checkbox>
        <span @click="handleAgreement">同意《壹心理用户提现协议》</span>
      </div>
      <div class="pop-btn-box">
        <div class="btn empty-btn" @click="handleWithdrawal">确认提现</div>
        <div class="btn solid-btn" @click="handleClose">取消</div>
      </div>
    </div>
  </Popup>
</template>

<script>
import Popup from '@/components/Popup'
import Checkbox from '@/components/Checkbox'
import { getWithdrawInfo } from '@/api/fundsManage'
import { bridge } from '@/mixins'

const withdrawalPath = `${location.protocol}//${location.host}/msite/index.html`
export default {
  name: 'WithdrawalPop',
  mixins: [bridge],
  props: {
    show: Boolean,
    number: Number,
    value: Boolean
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    result () {
      return (this.number * 0.1 * 0.8).toFixed(2)
    }
  },
  components: {
    Popup,
    Checkbox
  },
  methods: {
    handleWithdrawal () {
      if (this.loading) {
        return
      }
      this.loading = true
      // 同意提现协议
      if (!this.value) {
        this.$toast('请购选同意协议')
        this.loading = false
        return
      } else {
        this.$emit('confirm', true)
      }
      if (this.number <= 0) {
        this.$toast('暂无可提现金额')
        this.loading = false
        return
      }
      this.handleLiveWithdrawals()
    },
    handleLiveWithdrawals() {
      getWithdrawInfo()
        .then(res => {
          const { code, data, message } = res.data
          if (code === 40009) {
            this.withdrawalsUnusual(data.status, message)
          } else if (code === 0) {
            // this.replaceActiveIndex(1)
            this.openWebView({
              url: `${withdrawalPath}#/live-tixian?stamp=income&cancelWebView=1`,
              isCurrentPageOpen: 0,
              hideNavigationBar: 1
            })
          }
        })
        .catch(e => {
          console.error(e)
          this.$emit('withdrawError', e)
        })
        .finally(() => {
          this.loading = false
        })
    },
    withdrawalsUnusual (status, message) {
      switch (status) {
        case 1:
          this.$toast('每日可提现3次，您已超过次数')
          break
        case 2:
          this.$toast(message)
          break
        case 3:
          this.openDialog(
            '提现资料不完整，请设置后再操作提现',
            `${withdrawalPath}#/withdrawals-alipay-setting?stamp=income`
          )
          break
        case 5:
          this.openDialog(
            '你还未设置提现密码，请设置后再操作提现',
            `${withdrawalPath}#/withdrawals-pwd-setting?stamp=income`
          )
          break
      }
    },
    openDialog(title, url) {
      this.$dialog({
        title,
        theme: '#FFA202',
        id: 'no-identity-dialog',
        buttons: [
          {
            label: '暂不提现',
            onClick: () => {}
          },
          {
            label: '前往设置',
            onClick: () => {
              // this.replaceActiveIndex(1)
              // window.location.href = url
              this.openWebView({
                url,
                isCurrentPageOpen: 0,
                hideNavigationBar: 0
              })
            }
          }
        ]
      })
    },
    replaceActiveIndex (activeIndex) {
      this.$router.replace({
        name: 'income',
        query: {
          activeIndex
        }
      })
    },
    handleValue (value) {
      this.$emit('input', value)
    },
    handleAgreement () {
      this.$emit('read')
    },
    handleClose () {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../styles/mixins.scss';
.withdrawal-pop {
  background: #FFFFFF;
  border-radius: 30px;
  width: 600px;
  padding: 60px 0 48px;
  .pop-content {
    padding: 0 50px;
    text-align: center;
    p {
      font-family: PingFangSC-Medium;
      font-size: 32px;
      color: #21252D;
      margin-bottom: 20px;
    }
    span {
      font-family: PingFangSC-Regular;
      font-size: 26px;
      color: #7C8790;
    }
    .tip {
      margin: 10px;
      font-size: 26px;
      color: red;
    }
  }
  .pop-agreement {
    @include setBorder1px(top, rgba(234,234,234,1));
    padding-top: 48px;
    margin: 20px 36px 0;
    display: flex;
    align-items: center;
    .checkbox {
      margin-bottom: -4px;
      /deep/ .box {
        border-radius: 6px;
        &.not-select::before {
          border-radius: 15px;
        }
      }
    }
    span {
      font-family: PingFangSC-Regular;
      font-size: 28px;
      color: #7C8790;
      margin-left: 16px;
    }
  }
  .pop-btn-box {
    @include setBorder1px(top, rgba(234,234,234,1));
    margin: 48px 36px 0;
    padding-top: 48px;
    display: flex;
    justify-content: space-between;
    .btn {
      border-radius: 40px;
      width: 246px;
      height: 80px;
      line-height: 80px;
      text-align: center;
      font-family: PingFangSC-Regular;
      font-size: 28px;
    }
    .empty-btn {
      @include setBorder1px(all, #6982FA, 80px);
      color: #6982FA;
    }
    .solid-btn {
      color: #FFFFFF;
      background: #6982FA;
    }
  }
}
</style>
